import React from 'react'

import { DirectTask } from '@frame/lib/api/tasks/types'
import { isMarkedComplete, isVerifiedTask } from '@frame/lib/utils/tasks'

import { TaskList } from '../../components/task-list'
import { ConnectBankCard } from './connect-bank-card'
import { EmployerHistoryCard } from './employer-history-card'

type Props = {
  incomeTasks: DirectTask[]
  employmentTasks: DirectTask[]
  loadingTaskId: string | null
  handleConnectBank: (task: DirectTask) => void
  handleVerify: (task: DirectTask, index?: number) => Promise<void>
}

export function TaskContent({ incomeTasks, employmentTasks, loadingTaskId, handleConnectBank, handleVerify }: Props) {
  const shouldHideBank = incomeTasks.length === 0 || employmentTasks.some(isVerifiedTask)

  if (shouldHideBank) {
    return <TaskList tasks={employmentTasks} loadingTaskId={loadingTaskId} handleVerify={handleVerify} />
  }

  const hasIncomeTask = incomeTasks.length > 0
  const hasEmploymentTasks = employmentTasks.length > 0

  if (hasIncomeTask && hasEmploymentTasks) {
    return (
      <IncomeAndEmploymentTasks
        incomeTasks={incomeTasks}
        employmentTasks={employmentTasks}
        loadingTaskId={loadingTaskId}
        handleVerify={handleVerify}
        handleConnectBank={handleConnectBank}
      />
    )
  }

  // We only care about one income task, there shouldn't be more than one on the session
  if (hasIncomeTask) {
    return <TaskList tasks={[incomeTasks[0]]} loadingTaskId={loadingTaskId} handleVerify={handleConnectBank} />
  }

  return <TaskList tasks={employmentTasks} loadingTaskId={loadingTaskId} handleVerify={handleVerify} />
}

function IncomeAndEmploymentTasks({
  incomeTasks,
  employmentTasks,
  loadingTaskId,
  handleVerify,
  handleConnectBank,
}: Props) {
  const hasCompletedEmploymentTask = employmentTasks.some(isMarkedComplete)

  return (
    <>
      <ConnectBankCard handleConnectBank={() => handleConnectBank(incomeTasks[0])} isTenantVerifier />
      <div className="my-4" />
      {employmentTasks.length > 1 || hasCompletedEmploymentTask ? (
        <TaskList tasks={employmentTasks} loadingTaskId={loadingTaskId} handleVerify={handleVerify} />
      ) : (
        <EmployerHistoryCard task={employmentTasks[0]} handleVerify={handleVerify} isTenantVerifier />
      )}
    </>
  )
}
